import { renderSoftware, type SoftwareData, type SoftwareItem } from '../render/software.js';
import { initFilterablePage } from '../ui/filterable-page.js';
import { whenIdle } from '../ui/lazy-hydrate.js';

whenIdle(() => {
  void import('../layout.js').then(({ initLayout }) => initLayout());
});

initFilterablePage<SoftwareItem>({
  filterHostId: 'software-filters',
  gridHostId: 'software-grid',
  dataFile: 'Software.json',
  loadData: async (fileName) => {
    const { getJson } = await import('../services/json-service.js');
    const data = await getJson<SoftwareData>(fileName);
    return (data?.Recommendations ?? []).sort((a, b) =>
      (a.Title ?? '').localeCompare(b.Title ?? '')
    );
  },
  getCategories: (items) => [...new Set(items.flatMap((item) => item.Categories))].sort(),
  filterItems: (items, selected) => items.filter((item) => item.Categories.includes(selected)),
  renderItems: renderSoftware,
});
